import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import "focus-visible/dist/focus-visible";
import App from "./App";

const config = window.wpResources || {
  appSelector: "#root",
  version: "1.0.0",
  apiUrl: "https://expressinfo.test/wp-json/wp-resources/v1",
};
const { appSelector } = config;
const appAnchorElement =
  document.querySelector(appSelector) || document.querySelector("#root");

if (appAnchorElement) {
  ReactDOM.render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>,
    appAnchorElement
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
